// extracted by mini-css-extract-plugin
module.exports = {"alert-icon":"alert-dialog-component-module__edCY3G__alert-icon"};